module.exports = __webpack_public_path__ + "static/airbnb-logo-4fb0f7ef7561c558eb4e1efc7b0aaf0e.svg";